import { render, staticRenderFns } from "./CodeEditor.vue?vue&type=template&id=097e6036&"
import script from "./CodeEditor.vue?vue&type=script&lang=js&"
export * from "./CodeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CodeEditor.vue"
export default component.exports